import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Button,
  CircularProgress,
  Alert
} from '@mui/material';
import {
  CheckCircle,
  Receipt,
  Home
} from '@mui/icons-material';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [paymentInfo, setPaymentInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const externalReference = searchParams.get('external_reference');
    // const paymentId = searchParams.get('payment_id');
    // const collectionStatus = searchParams.get('collection_status');
    
    if (externalReference) {
      // Extraer el saleId del external_reference (formato: SALE-{timestamp})
      // En producción, deberías tener una forma mejor de obtener el saleId
      loadPaymentStatus(externalReference);
    } else {
      setError('No se encontró información de la venta');
      setLoading(false);
    }
  }, [searchParams]);

  const loadPaymentStatus = async (externalReference) => {
    try {
      // Aquí deberías tener una forma de convertir el external_reference al saleId
      // Por ahora, mostraremos la información disponible
      setPaymentInfo({
        externalReference,
        status: 'approved'
      });
      setLoading(false);
    } catch (error) {
      console.error('Error al verificar pago:', error);
      setError('Error al verificar el estado del pago');
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container maxWidth="sm">
        <Box className="d-flex flex-column align-center justify-center" sx={{ minHeight: '60vh' }}>
          <CircularProgress size={60} className="mb-md" />
          <Typography variant="h6">Verificando pago...</Typography>
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="sm">
        <Box sx={{ minHeight: '60vh', display: 'flex', alignItems: 'center' }}>
          <Card sx={{ width: '100%' }}>
            <CardContent className="text-center">
              <Alert severity="error" className="mb-md">
                {error}
              </Alert>
              <Button
                variant="contained"
                startIcon={<Home />}
                onClick={() => navigate('/')}
              >
                Volver al Inicio
              </Button>
            </CardContent>
          </Card>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm">
      <Box sx={{ minHeight: '60vh', display: 'flex', alignItems: 'center', py: 4 }}>
        <Card sx={{ width: '100%' }}>
          <CardContent className="text-center">
            <CheckCircle
              sx={{ fontSize: 80, color: 'success.main', mb: 2 }}
            />
            
            <Typography variant="h4" className="mb-md font-bold">
              ¡Pago Exitoso!
            </Typography>
            
            <Typography variant="body1" color="text.secondary" className="mb-lg">
              Tu compra ha sido procesada correctamente
            </Typography>

            {paymentInfo && (
              <Box className="mb-lg">
                <Card variant="outlined">
                  <CardContent>
                    <Box className="d-flex justify-between mb-sm">
                      <Typography variant="body2" color="text.secondary">
                        Referencia:
                      </Typography>
                      <Typography variant="body2" className="font-semibold">
                        {paymentInfo.externalReference}
                      </Typography>
                    </Box>
                    
                    <Box className="d-flex justify-between">
                      <Typography variant="body2" color="text.secondary">
                        Estado:
                      </Typography>
                      <Typography variant="body2" className="font-semibold" color="success.main">
                        Aprobado
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            )}

            <Alert severity="info" className="mb-lg">
              Recibirás un correo electrónico con los detalles de tu compra.
            </Alert>

            <Box className="d-flex gap-sm justify-center">
              <Button
                variant="outlined"
                startIcon={<Receipt />}
                onClick={() => navigate('/ventas')}
              >
                Ver Ventas
              </Button>
              <Button
                variant="contained"
                startIcon={<Home />}
                onClick={() => navigate('/')}
              >
                Volver al Inicio
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default PaymentSuccess;

